import { ApiModule, type PaginatedResponseData } from '@common/index';
import type { QualificationItem, Qualification } from '../models';

export class QualificationApi extends ApiModule {
  protected endpoint = '/qualification';

  public async pageQualifications(params: any) {
    return this.api.post<PaginatedResponseData<QualificationItem>, any>(
      `${this.endpoint}/page?page=${params.page}&size=${params.itemsPerPage}&sort=${params.sort ?? ''}&sort=${params.sort ?? ''}`,
      {
        ...params
      }
    );
  }

  public loadQualificationDetails(id: number) {
    return this.api.get<Qualification>(`${this.endpoint}?id=${id}`);
  }

  public saveQualification(params: any) {
    return this.api.post(`${this.endpoint}`, {
      ...params
    });
  }

  public deleteQualification(id: number) {
    return this.api.delete(`${this.endpoint}?id=${id}`);
  }
}
